import React, { useContext, useEffect, useState, useRef } from 'react'
import "./Header.css"
import { Link } from 'react-router-dom';
import { ReactComponent as InplayIconMini } from "../../Icons/other-icons/InplayIconMini.svg"
import WatchLaterOutlinedIcon from '@mui/icons-material/WatchLaterOutlined';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import { ReactComponent as WalletIcon } from "../../Icons/header-icons/walletIcon.svg"
import { ReactComponent as ProfileIcon } from "../../Icons/header-icons/profileIcon.svg"
import { ExchangeContexts } from '../../context/ExchangeContext';
import Person2Icon from '@mui/icons-material/Person2';
import CloseIcon from '@mui/icons-material/Close';
import Humburger from '../ExchangeComponents/Humburger/Humburger';
import { useLocation, useNavigate } from 'react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { getFormattedDateTime } from "../../Utilities/uitility"
import { User_Context } from '../../context/User';
import ExposureIcon from '@mui/icons-material/Exposure';
import { Theme_Context } from '../../context/Theme';
const Header = () => {
    const location = useLocation();
    const navigate = useNavigate()
    const { showProfileBox, setShowProfileBox, openSidebar, setOpenSidebar } = useContext(ExchangeContexts);
    const isTabOrMobile = window.matchMedia("(max-width: 768px)").matches;
    const [{ formattedDate, formattedTime }, setDateTime] = useState(() => getFormattedDateTime());
    const { User, Set_User } = useContext(User_Context);
    const { Theme, Set_Theme } = useContext(Theme_Context)
    const profileBoxRef = useRef(null);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setDateTime(getFormattedDateTime());
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    const handleHumburgerClick = () => {
        setOpenSidebar(!openSidebar)
    }

    // Handle click outside to close profile box
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (profileBoxRef.current && !profileBoxRef.current.contains(event.target)) {
                setShowProfileBox(false);
            }
        };

        if (showProfileBox) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showProfileBox, setShowProfileBox]);

    const handleTheme = (type) => {
        Set_Theme({ theme: type });
        setShowProfileBox(!showProfileBox);
    };


    const handleProfileTabClick = () => {
        setShowProfileBox(!showProfileBox);
    }

    return <>
        <header className={`exchange-main-header_ ${Theme.theme}`}>
            <nav className="exchange-main-nav_">
                <div className="exchange-main-header-left_">
                    {isTabOrMobile && <Humburger onClick={handleHumburgerClick} className={"humburgerIcon"} showHumburger={!openSidebar} />}
                    {!isTabOrMobile && <div onClick={() => navigate("/")} className="header-bridcrumbs_" ><span className="page">Home</span> <InplayIconMini className='inplay-icon-mini_' /></div>}
                </div>
                <div className="exchange-main-header-right">
                    <div className="today-date-time_">
                        <div className="header-date_"><WatchLaterOutlinedIcon className='watch-icon_' />{formattedDate} </div>
                        <div className="header-time_">{formattedTime}</div>
                    </div>

                    <div hidden={!User.token} className={`user-wallet-box_ ${Theme.theme}`}>
                        <div className="wallet-box-wrapper_">
                            <WalletIcon className="wallet-icon_" />
                            <div className="wallet-balance"> {User?.data?.currencyCode} {User.data.balance}</div>
                            {/* <ReplayOutlinedIcon className='reload-icon' /> */}
                        </div>
                    </div>

                    <div hidden={!User.token} className="profile-header-view_" ref={profileBoxRef}>
                        <div className={`header-profile-icon_ ${Theme.theme}`} onClick={handleProfileTabClick}>
                            {showProfileBox ? <CloseIcon className='close-profile-icon_' /> : <Person2Icon className="profile-icon_" />}
                        </div>
                        {/* Profile box */}
                        {
                            showProfileBox &&
                            <div className={`user-profile-box ${Theme.theme}`}>
                                <div className="user-profile-box-wrapper">
                                    {/* <div className={`profile-box-header ${Theme.theme}`}>{User.data.displayName}</div> */}
                                     <div className={`profile-box-header profile-details-row ${Theme.theme}`}>
                                        <div className="profile-details-row-container_">
                                            <AccountCircleIcon className={`profile-details-icon ${Theme.theme}`} />
                                            <div className={`profile-details-detail ${Theme.theme}`}>{User.data.displayName}</div>
                                        </div>
                                    </div>
                                    <div className={`profile-details-row ${Theme.theme}`}>
                                        <div className="profile-details-row-container_">
                                            <ExposureIcon className={`profile-details-icon ${Theme.theme}`} />
                                            <div className={`profile-details-detail ${Theme.theme}`}>  Exposure <span className={`total-exposure_ ${Theme.theme}`}>{User.data.exposure?.toFixed(2)}</span> </div>
                                        </div>
                                    </div>
                                    {/* <div className={`profile-details-row ${Theme.theme}`}>
                                        <div className="profile-details-row-container_">
                                            <AccountCircleIcon className={`profile-details-icon ${Theme.theme}`} />
                                            <div className={`profile-details-detail ${Theme.theme}`}>{User.data.displayName}</div>
                                        </div>
                                    </div> */}
                                   
                                    <div className={`profile-details-row ${Theme.theme}`}>
                                        <div className="profile-details-row-container_" onClick={handleProfileTabClick}>
                                            <EmojiEventsIcon className={`profile-details-icon ${Theme.theme}`} />
                                            <Link to={"bets/profit-loss"} className={`profile-details-detail ${Theme.theme}`}>Profit & Loss</Link>
                                        </div>
                                    </div>
                                    <div className={`profile-details-row ${Theme.theme}`}>
                                        {Theme.theme === "DARK" ? (
                                            <div
                                                onClick={() => handleTheme("LIGHT")}
                                                className="profile-details-row-container_"
                                            >
                                                <DarkModeIcon className={`profile-details-icon ${Theme.theme}`} />

                                                <div className={`profile-details-detail ${Theme.theme}`}>Light Theme</div>
                                            </div>
                                        ) : (
                                            <div
                                                onClick={() => handleTheme("DARK")}
                                                className="profile-details-row-container_"
                                            >
                                                <LightModeIcon className={`profile-details-icon ${Theme.theme}`} />
                                                <div className={`profile-details-detail ${Theme.theme}`}>Dark Theme</div>
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </div>
                        }
                        {/* end of profile box */}
                    </div>
                </div>
            </nav>
        </header>
    </>
}

export default Header